import api from '@/utils/api'

export default class MenuService {
    public static list(siteCd: string, callback: (result: any) => void): void {
        api.get(`api/menu/list`).then((r) => callback(r))
    }
}